var elementsForm,contLogin;
var numberListCreateProspect = 1,idDeleteCreateProspect= 1,arvCreateProspect=1;
scriptArCreateProspect = new Array();
scriptArCreateProspect[0] = "no";
scriptArCreateProspect[1] = "si";
arvCreateProspect = scriptArCreateProspect.toString();
$('#numberList').val(arvCreateProspect);
function deleteNew(id){
    idDeleteCreateProspect = id;
    $('.contact-add'+idDelete).remove();
    scriptArCreateProspect[id] = "no";
    arvCreateProspect = scriptArCreateProspect.toString();
    $('#numberList').val(arvCreateProspect);
}
$( document ).ready(function() {
    $('.add-new-contact').click(function () {
        $('.add-new-contact').css('visibility','hidden');
        numberListCreateProspect = numberListCreateProspect + 1;
        scriptArCreateProspect[numberListCreateProspect] = "si";
        arvCreateProspect = scriptArCreateProspect.toString();
        $('#numberList').val(arvCreateProspect);
        $('.moreContact').append('' +
            '<div class="container-createClient">\n' +
            '    <div class="container-select-2">\n' +
            '        <div class="row">\n' +
            '            <div class="col l2">\n' +
            '                <h1>\n' +
            '                    <span>Contacto</span> 0'+numberListCreateProspect+'\n' +
            '                </h1>\n' +
            '            </div>\n' +
            '            <div class="col l8">\n' +
            '                <h1 class="align-center">\n' +
            '                    Datos de contacto\n' +
            '                </h1>\n' +
            '            </div>\n' +
            '            <div class="col l2">\n' +
            '                <h3 class="add-new-contact" onclick="$(\'#add-new-contact\').click();"">\n' +
            '                    <img src="'+https+'img/icons/add_purple_circle_2.svg" alt="">\n' +
            '                    Agregar Contacto\n' +
            '                </h3>' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '    <div class="form align-center">\n' +
            '        <div class="row">\n' +
            '            <div class="col l3">\n' +
            '                <h1>\n' +
            '                    Nombre\n' +
            '                </h1>\n' +
            '                <input id="name_'+numberListCreateProspect+'" name="name_'+numberListCreateProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l2">\n' +
            '                <h1>\n' +
            '                    Cargo\n' +
            '                </h1>\n' +
            '                <input id="position_'+numberListCreateProspect+'" name="position_'+numberListCreateProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l3">\n' +
            '                <h1>\n' +
            '                    Departamento\n' +
            '                </h1>\n' +
            '                <input id="department_'+numberListCreateProspect+'" name="department_'+numberListCreateProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l4">\n' +
            '                <h1>\n' +
            '                    Mail\n' +
            '                </h1>\n' +
            '                <input id="mail_'+numberListCreateProspect+'" name="mail_'+numberListCreateProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '        </div>\n' +
            '        <div class="row">\n' +
            '            <div class="col l3">\n' +
            '                <h1>\n' +
            '                    Telefono\n' +
            '                </h1>\n' +
            '                <input id="phone_'+numberListCreateProspect+'" name="phone_'+numberListCreateProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l1">\n' +
            '                <h1>\n' +
            '                    Ext\n' +
            '                </h1>\n' +
            '                <input id="ext_'+numberListCreateProspect+'" name="ext_'+numberListCreateProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l3">\n' +
            '                <h1>\n' +
            '                    Celular\n' +
            '                </h1>\n' +
            '                <input id="cellphone_'+numberListCreateProspect+'" name="cellphone_'+numberListCreateProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l5">\n' +
            '                <h1>\n' +
            '                    Nota\n' +
            '                </h1>\n' +
            '                <input id="note_'+numberListCreateProspect+'" name="note_'+numberListCreateProspect+'" type="text" class="input">\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>');
    });
});

$('.btnAddProspect').click(function () {
   $('#formCreateProspect').submit();
});

$("#formCreateProspect").on('submit', function (e) {
    e.preventDefault();
    elementsForm = [
        "date",
        "status_prospects",
        "name",
        /*
        "nit",
        "web",
        "web_status",
        "address",
        "city",
        "phone",
        "mail",
        "sector",
        */
        "numberList",
    ];
    /*
    for(i=0;i<scriptArCreateProspect.length;i++){
        if(scriptArCreateProspect[i] == 'si'){
            elementsForm.push('name_'+i);
            elementsForm.push('position_'+i);
            elementsForm.push('department_'+i);
            elementsForm.push('mail_'+i);
            elementsForm.push('phone_'+i);
            elementsForm.push('cellphone_'+i);
            elementsForm.push('note_'+i);
        }
    }
    */
    contLogin = validationForm(elementsForm,contLogin = 1);

    if(contLogin == 0)
    {
        swal({
            text: "Debes completar todos los datos",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }

    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });
    var data = $(this).serialize();
    $.ajax({
        url: https + "createProspect",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formCreateProspect")[0].reset();
                swal.close();
                swal({
                    text: "Prospecto Creado con exito",
                    icon: imageURL,
                    button: "OK!",
                });
                setInterval(function () {
                    location.href = https + 'prospectos';
                }, 200)
            }else if($.trim(data) == "2") {
                swal({
                    text: "No tiene los permisos necesarios",
                    icon: imageURL,
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){

        $('#'+elementsForm[i]).removeClass('error');

        if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
            contLogin = 0;
            $('#'+elementsForm[i]).addClass('error');
        }

    }

    return contLogin;
}

$('.si_web_status').click(function () {
   $('#web_status').val('si');
    $("#si_web_status").prop('checked', true);
    $("#no_web_status").prop('checked', false);
});
$('.no_web_status').click(function () {
    $('#web_status').val('no');
    $("#si_web_status").prop('checked', false);
    $("#no_web_status").prop('checked', true);
});

$('#select_id_users_asesor').change(function () {
    $('#id_users_asesor').val($(this).val())
});